import { render, staticRenderFns } from "./chain-add-or-update.vue?vue&type=template&id=57817fd6"
import script from "./chain-add-or-update.vue?vue&type=script&lang=js"
export * from "./chain-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports